<template>
    <div component="doc">
        <div class="content">
            <section class="header">
                <h1>FORMS</h1>
            </section>
            <section class="remote">prepínač</section>
            <section class="body">
                <div class="form">
                    <!-- <input type="text"> -->

                    <div class="row">
                        <div class="input" required="true">
                            <label>write something</label>
                            <input type="text" />
                        </div>
                        <textarea class="code">
<div class="input">
	<label>write something</label>
	<input type="text">
</div></textarea
                        >
                    </div>

                    <!-- <input type="number"> -->

                    <div class="row">
                        <div class="input">
                            <label>number input</label>
                            <input type="number" />
                        </div>
                        <textarea class="code">
<div class="input">
	<label>number input</label>
	<input type="number">
</div></textarea
                        >
                    </div>

                    <div class="row">
                        <div class="input" required="true">
                            <label>email input</label>
                            <input type="email" />
                        </div>
                        <textarea class="code"></textarea>
                    </div>

                    <div class="row">
                        <div class="input" required="false">
                            <label>phone input</label>
                            <input type="phone" />
                        </div>
                        <textarea class="code"></textarea>
                    </div>

                    <div class="row">
                        <div class="input" required="true">
                            <label>write something</label>
                            <textarea></textarea>
                        </div>
                        <textarea class="code"></textarea>
                    </div>

                    <div class="row">
                        <div class="input">
                            <label></label>
                            <select>
                                <option>choose something</option>
                                <option>Value 2</option>
                                <option>Value 3</option>
                            </select>
                        </div>
                        <textarea class="code"></textarea>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'FormDoc',

    data() {
        return {};
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Doc'] {
    section.body {
        // border: none;

        .form {
            padding: 20px;

            .row {
                display: flex;
                align-items: center;
                border-bottom: 1px solid @grey_ltr;

                .input {
                    width: 300px;
                }
                .code {
                    width: 300px;
                    height: 100px;
                    border-radius: 0px;
                    margin-left: 30px;
                    border-width: 0px 0px 0px 1px;
                    border-color: @grey_ltr;
                    margin-bottom: 0px;
                }
            }
        }
    }
}
</style>
